/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Prompt_Placeholder_BuildInputs */



/**
* | output |
* | --- |
* | "What are we building today?" |
*
* @param {Chat_Prompt_Placeholder_BuildInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_prompt_placeholder_build = /** @type {((inputs?: Chat_Prompt_Placeholder_BuildInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Prompt_Placeholder_BuildInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was bauen wir heute?")
	return /** @type {LocalizedString} */ ("What are we building today?")
});